module.exports = __webpack_public_path__ + "media/images/icons/price-68b329da9893e34099c7d8ad5cb9c940.svg";